@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackAllie {
  display: flex;
  flex-direction: column;
  color: var(--black);
  gap: 30px;
  padding: 50px 0;

  .bigTitle {
    max-width: 900px;
    font-size: 28px;

    @include texts.font("semi-bold");
  }

  .cases {
    display: flex;
    gap: 20px;

    .case {
      padding: 40px 30px;
      display: flex;
      width: 33.33%;
      gap: 25px;
      flex-direction: column;
      position: relative;
      border-radius: 16px;
      background: var(--grey-sur-light);

      .name {
        gap: 15px;
        font-size: 20px;
        display: flex;
        align-items: center;

        @include texts.font("semi-bold");

        h3 {
          font-size: 20px;
        }

        .icon {
          flex: 0 0 36px;
          width: 36px;
          height: 36px;

          &.chart {
            @include icons.ico("black-line-chart");
          }

          &.speedometer {
            @include icons.ico("black-speedometer");
          }

          &.refresh {
            @include icons.ico("black-refresh");
          }
        }
      }

      .description {
        font-size: 15px;
      }

      .icons {
        display: flex;
        gap: 25px;
      }
    }
  }

  @media screen and (max-width: 930px) {
    padding: 0;

    .cases {
      flex-wrap: wrap;

      .case {
        width: 100%;

        .illus {
          flex: 0 0 80px !important;
          width: 80px !important;
          height: 100px !important;
        }
      }
    }
  }
}